import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://bea3e52c8bb73f6a53671fec8b44020d@o1293080.ingest.us.sentry.io/4510228083179520",
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  denyUrls: [
    /chrome-extension:\/\//,
    /firefox-extension:\/\//,
    /safari-extension:\/\//,
    /edge-extension:\/\//,
    /opera-extension:\/\//,
    /vivaldi-extension:\/\//,
    /brave-extension:\/\//,
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
